var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListForSaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0319 2.56641H8.61062C8.33079 2.56641 8.06204 2.67781 7.86405 2.8758L2.10907 8.62973C1.69672 9.04208 1.69672 9.7105 2.10907 10.1234L6.53037 14.5447C6.94273 14.957 7.61115 14.957 8.0235 14.5447L13.7785 8.79076C13.9765 8.59224 14.0879 8.3235 14.0879 8.04314V3.62237C14.0879 3.03895 13.6153 2.56641 13.0319 2.56641ZM11.184 6.26227C10.7468 6.26227 10.392 5.90746 10.392 5.4703C10.392 5.03313 10.7468 4.67833 11.184 4.67833C11.6212 4.67833 11.976 5.03313 11.976 5.4703C11.976 5.90746 11.6212 6.26227 11.184 6.26227Z",
    fill: "#002979"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1441 3.62244L15.1435 8.5374C15.1435 8.7808 15.0469 9.0147 14.8743 9.18682L9.02637 15.0347L9.11612 15.1245C9.52847 15.5368 10.1969 15.5368 10.6092 15.1245L15.8901 9.84468C16.0886 9.64669 16.2 9.37795 16.2 9.09812V4.6784C16.2 4.09498 15.7275 3.62244 15.1441 3.62244Z",
    fill: "#002979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListForSaleIcon);
export default __webpack_public_path__ + "static/media/list-for-sale-icon.6885daadccf583bc9c174427e484ad07.svg";
export { ForwardRef as ReactComponent };